import { TableMenuItem, useCurrentUser } from '@qualio/ui-components';
import { useArchiveTemplate, useRestoreTemplate, useCreateNewDraftTemplate } from './hooks';
import { EventType } from '../../../types';
import * as DisplayStrings from '../../../displayStrings';
import { eventTemplateRowActions } from '../../../utils/eventTemplatePermissionUtils';

type TemplateRowActionsProps = {
  companyId: number;
  setTemplateForMakeEffective: (templateId: number, lineageId: string) => void;
  setTemplateForChangeOwner: (templateId: number, lineageId: string, ownerName: string, ownerId: string) => void;
  setTemplateForDeleteDraft: (templateId: number, lineageId: string) => void;
};

const TemplateRowActions = ({
  companyId,
  setTemplateForMakeEffective,
  setTemplateForChangeOwner,
  setTemplateForDeleteDraft,
}: TemplateRowActionsProps) => {
  const { mutate: archiveTemplate } = useArchiveTemplate(companyId);
  const { mutate: restoreTemplate } = useRestoreTemplate(companyId);
  const { mutate: createNewDraftTemplate } = useCreateNewDraftTemplate(companyId);
  const { userId, userGroups } = useCurrentUser();
  const role = userGroups[0];
  const isQualityUser = role === 'quality';

  const actionsFor = (template: EventType) => eventTemplateRowActions(template, userId, isQualityUser);

  return (
    <>
      <TableMenuItem
        data-cy="archive-template"
        onClick={(template: EventType) => archiveTemplate(template.id)}
        isHidden={(template: EventType) => !actionsFor(template).showArchive}
      >
        Archive
      </TableMenuItem>
      <TableMenuItem
        data-cy="restore-template"
        onClick={(template: EventType) => restoreTemplate(template.id)}
        isHidden={(template: EventType) => !actionsFor(template).showRestore}
      >
        Restore
      </TableMenuItem>
      <TableMenuItem
        data-cy="create-template-draft"
        onClick={(template: EventType) => createNewDraftTemplate(template.lineage_id!)}
        isHidden={(template: EventType) => !actionsFor(template).showCreateDraft}
      >
        {DisplayStrings.CreateTemplateDraft}
      </TableMenuItem>
      <TableMenuItem
        data-cy="make-template-effective"
        onClick={(template: EventType) => setTemplateForMakeEffective(Number(template.id), template.lineage_id)}
        isHidden={(template: EventType) => !actionsFor(template).showMakeEffective}
      >
        {DisplayStrings.MakeEffective}
      </TableMenuItem>
      <TableMenuItem
        data-cy="change-owner"
        onClick={(template: EventType) => {
          if (template.owner) {
            setTemplateForChangeOwner(
              Number(template.id),
              template.lineage_id,
              template.owner,
              String(template.ownerId),
            );
          }
        }}
        isHidden={(template: EventType) => !actionsFor(template).showChangeOwner}
      >
        {DisplayStrings.ChangeTemplateOwner}
      </TableMenuItem>
      <TableMenuItem
        data-cy="delete-draft-template"
        onClick={(template: EventType) => setTemplateForDeleteDraft(Number(template.id), template.lineage_id)}
        isHidden={(template: EventType) => !actionsFor(template).showDeleteDraft}
      >
        {DisplayStrings.DeleteDraft}
      </TableMenuItem>
    </>
  );
};

export default TemplateRowActions;
